
      import '@folkjs/labs/standalone/folk-sand';
      import '@folkjs/labs/folk-random';

      const alchemicalSymbols =
        '🜁🜂🜃🜄🜅🜆🜇🜈🜉🜊🜋🜌🜍🜎🜏🜐🜑🜒🜓🜔🜕🜖🜗🜘🜙🜚🜛🜜🜝🜞🜟🜠🜡🜢🜣🜤🜥🜦🜧🜨🜩🜪🜫🜬🜭🜮🜯🜰🜱🜲🜳🜴🜵🜶🜸🜹🜺🜻🜼🜾🜿🝀🝁🝂🝃🝄🝅🝆🝈🝉🝊🝋🝌🝍🝎🝏🝐🝑🝒🝓🝔🝕🝖🝗🝘🝙🝚🝛🝜🝝🝞🝟🝠🝡🝢🝣🝤🝥🝦🝧🝩🝪🝬🝭🝮🝯🝰🝲🝳';

      const questionItems = document.querySelectorAll('#questions li');
      questionItems.forEach((li) => {
        const symbols = [...alchemicalSymbols];
        const randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];
        li.setAttribute('data-symbol', randomSymbol);
      });
    